import { ERROR_TYPE } from '@/features/game-window-integration/helpers/error-mapping';
import { ProviderAdaptor } from '@/features/game-window-integration/providers/generic-provider/payload-adaptors/contracts';
import { runProcessError } from '@/features/game-window-integration/providers/generic-provider/payload-adaptors/process-error';
import {
  ExtendableGenericEvents,
  GenericEvents,
} from '@/features/game-window-integration/providers/generic-provider/types';

const eventsRemap: ProviderAdaptor['eventsRemap'] = {
  [GenericEvents.RELOAD_BALANCE]: 'refreshBalance',
  // Keeps GW disabled during a spin and re-enables it when GMR returns to idle.
  [GenericEvents.SPIN_IN_PROGRESS]: 'gameBusy',
  [GenericEvents.SPIN_IN_PROGRESS_ENDED]: 'gameIdle',
  // GMR exposes Paytable and How To Play in the same modal.
  [GenericEvents.TOGGLE_PAYTABLE]: GenericEvents.TOGGLE_HELP,
};

export const gamingRealmsAdaptor: ProviderAdaptor = {
  eventsRemap,

  errorCodesRemap: {
    ACCOUNT_LIMIT_EXCEEDED: ERROR_TYPE.GENERIC,
    CONNECTION_ERROR: ERROR_TYPE.CONNECTION_LOST,
    GENERIC_ERROR: ERROR_TYPE.GENERIC,
    INSUFFICIENT_BALANCE: ERROR_TYPE.INSUFFICIENT_FUNDS,
    INVALID_TOKEN: ERROR_TYPE.SESSION_EXPIRED,
    SERVER_ERROR: ERROR_TYPE.GENERIC,
    TIME_LIMIT_REACHED: ERROR_TYPE.GENERIC,
    USER_NOT_AUTHENTICATED: ERROR_TYPE.SESSION_EXPIRED,
    USER_SPENDING_BUDGET_EXCEEDED: ERROR_TYPE.GENERIC,
  },

  errorMessages: {
    ACCOUNT_LIMIT_EXCEEDED: 'The player has reached their wager limit.',
    CONNECTION_ERROR:
      'We lost connection to the game. Please try again or return to the lobby.',
    GENERIC_ERROR:
      "We're sorry about this. Please try again or leave your game to go home.",
    INSUFFICIENT_BALANCE:
      'There are not enough funds. Please top up your balance.',
    INVALID_TOKEN:
      'Your session has expired. Please try again or return to the lobby.',
    SERVER_ERROR:
      "We couldn't process your request. Please try again or return to the lobby.",
    TIME_LIMIT_REACHED: 'The player has reached their time limit.',
    USER_NOT_AUTHENTICATED: 'Invalid token. Authentication failed.',
    USER_SPENDING_BUDGET_EXCEEDED: 'The player has reached their loss limit.',
  },

  adaptInbound: (providerData) => ({ ...providerData }),

  adaptOutbound: (eventToProvider, notify, payload) => ({
    type: eventToProvider as unknown as ExtendableGenericEvents,
    source: 'fanduel',
    ...(notify && { stateChangeMessageType: eventToProvider }),
    ...(payload !== undefined && { payload }),
  }),

  processError(error) {
    return runProcessError(error, this.errorCodesRemap, this.errorMessages);
  },
};
